// Per-template field validation rules: which columns each goAML template validates and with which
// validator (see shared/validation.js). Shared so the web grid can validate cells as they are entered
// with exactly the same rules the server applies on submit.
const { FIUTemplatesTypes } = require('./index');
const consts = require('./consts.js');
const T = FIUTemplatesTypes;

const fieldsInUse = {
    'Transaction Type': {validator_key: 'transmode_code'},
    "Date": {validator_key: 'js_date'},
    'Time of Transaction': {validator_key: 'js_time'},
    'Swift': {validator_key: 'swift'},
    'Role': {validator_key: 'role'},
    'Description': {
        validator_key: 'transaction_description', skip_null: true,
        exclude_skipping_null: [T.BANK_ACCOUNT_TRANSFER]
    },
    'Funds Type': {validator_key: 'funds_code'},
    'Name Account Holder': {validator_key: 'account_name'},
    'Business Type': {validator_key: 'business'},
    'Incorporation Number': {validator_key: 'incorporation_number'},
    'Incorporation Country': {validator_key: 'country_extended'},
    'Tax Number': {validator_key: 'tax_number' },
    'Address Type': {validator_key: 'address_type'},
    'Address': {validator_key: 'address' },
    'City': {validator_key: 'city' },
    'Zip': {validator_key: 'zip', skip_null: true},
    'Country': {validator_key: 'country_extended'},
    'Account Number': {validator_key: 'account'},
    'Account Number Entity': {validator_key: 'account'},
    'Institution Name': {validator_key: 'institution_name'},
    "Currency Code": {validator_key: 'currency_code'},
    'Foreign Amount': {validator_key: 'foreign_amount'},
    "Reason": {validator_key: 'reason' , skip_null: true, 
        // exclude_skipping_null: [T[0]]
    },
    'Scenario': {validator_key: 'scenario'},
    'PSP Name': {validator_key: 'institution_name', skip_null: true},
    "Institution Name - My Client": { validator_key: 'institution_name'},
    "Gender": { validator_key: 'gender'},
    "First Name": { validator_key: 'account_name'},
    "Last Name": { validator_key: 'account_name'},
    "Birth Date": { validator_key: 'js_date'},
    "ID Number": { validator_key: 'account'},
    "Birth Place": { validator_key: 'address', skip_null: true},
    "Player Account Id": { validator_key: 'account'},
    "Nationality": { validator_key: 'country'},
    "Birthplace": { validator_key: 'account_name', skip_null: true},
    "Residence": { validator_key: 'country'},
    "Passport Number": { validator_key: 'account', skip_null: true},
    "Passport Country": { validator_key: 'country' },
    "Source of Funds": { validator_key: 'reason'},
    "Type": { validator_key: 'identification_type'},
    "Number": { validator_key: 'account'},
    "Issue Date": { validator_key: 'js_date'},
    "Expiry Date": { validator_key: 'js_date'},
    "Issue Country": { validator_key: 'country'},
    "Reporting entity's Institution Name": { validator_key: 'institution_name'},
    "Incorporation Legal Form": { validator_key: 'legal_form'},
    "Email": { validator_key: 'email', skip_null: true},
    "Institution Name - Client": { validator_key: 'institution_name'},
    "Transfer Type": { validator_key: 'transfer_type'},
}


const card_bankTransferFields = [
    'Date', 'Time of Transaction', 'Transfer Type', 'Player Account Id',
    'First Name', 'Last Name', 'Institution Name - Client',
    'Account Number', 'Institution Name', 'Swift', 'Currency Code', 
    'Foreign Amount', 'Description', 'Reason'
]

const reportToFielsMap = {

    [T.BANK_ACCOUNT_TRANSFER]: [
        'Transaction Type', 'Date', 'Time of Transaction', 
        'Swift', 'Role', 'Description', 'Funds Type', 'Name Account Holder', 'Business Type',
        'Incorporation Number', 'Incorporation Country', 'Tax Number', 'Address Type', 'Address', 
        'City', 'Zip', 'Country', 'Account Number', 'Institution Name', 
        'Currency Code', 'Foreign Amount', 'Reason'
    ],

    [T.BANK_MERCHANT_TRANSFER]: [
        'Date', 'Time of Transaction',
        'Role', 'Funds Type', 
        'Country', 'Account Number', 'Institution Name',
        'Currency Code', 'Foreign Amount', 'Description', 'Reason'
    ],

    [T.DEPOSIT_VIA_PSP]: [
        'Date', 'Time of Transaction', 'PSP Name', 'Player Account Id',
        'Institution Name',
        'Gender', 'First Name', 'Last Name', 'Birth Date', 'Birth Place', "Email",
        'ID Number', 'Nationality', 'Passport Number', 'Passport Country',
        'Residence', 'Source of Funds', 
        'Address', 'City', 'Zip', 'Country',
        'Type', 'Number', 'Issue Date', 'Expiry Date', 'Issue Country',
        'Currency Code', 'Foreign Amount', 'Description', 'Reason',
    ],

    [T.WIRE_TRANSFER_TRANSACTIONS]: card_bankTransferFields,
    [T.CREDIT_CARD_TRANSACTIONS]: card_bankTransferFields,

    [T.WITHDRAWAL_VIA_PSP]: [
        'Date', 'Time of Transaction', 
        'Account Number', 'Institution Name', 'Country',
        'Player Account Id', 'First Name', 'Last Name',
        'Institution Name - My Client',
        'Currency Code', 'Foreign Amount', 'Description', 'Reason' 
    ],
    /// DONE ///
    [T.PAYOUT_TRANSACTION]: [
        'Date', 'Time of Transaction', 'Player Account Id',
        'Institution Name', 
        'Gender', 'First Name', 'Last Name', 'Birth Date', 'Birth Place', "Email",
        'ID Number', 'Nationality', 'Passport Number', 'Passport Country',
        'Residence', 'Source of Funds', 
        'Address', 'City', 'Zip', 'Country',
        'Type', 'Number', 'Issue Date', 'Expiry Date', 'Issue Country',
        'Currency Code', 'Foreign Amount', 'Description', 'Reason',
    ],

    /// DONE ///
    [T.BANK_TO_BANK_INCOME_B2B]: [ 
        'Transaction Type', 'Date', 'Time of Transaction', 'Account Number Entity',
        "Reporting entity's Institution Name", "Role", 'Funds Type', 'Name Account Holder',
        'Incorporation Legal Form', 'Business Type', 'Incorporation Number', 'Incorporation Country',
        'Address Type', 'Address', 'City', 'Zip', 'Country', 
        'Currency Code', 'Foreign Amount', 'Description', 'Reason'
    ],
}

// { columnName: { validator_key, skip_null } } for a template; skip_null already accounts for
// exclude_skipping_null. Unknown template types give {}.
function templateValidationRules(templateType) {
    const rules = {};
    for (const name of reportToFielsMap[templateType] || []) {
        const field = fieldsInUse[name];
        if (!field?.validator_key) continue;
        rules[name] = {
            validator_key: field.validator_key,
            skip_null: !!field.skip_null && !(field.exclude_skipping_null || []).includes(templateType),
        };
    }
    return rules;
}

// Accepted values for validators that check against a fixed list (see shared/validation.js);
// the web grid offers them as dropdown options. Lowercase alias keys are left out.
const countryNames = Object.keys(consts.countries).filter(name => name !== 'unknown' && name !== 'Unknown');
const VALIDATOR_OPTIONS = {
    transmode_code: Object.keys(consts.transmode_code),
    funds_code: Object.keys(consts.fund_code_type),
    role: Object.keys(consts.party_role_type),
    gender: Object.keys(consts.gender_vars),
    gender_inverse: Object.keys(consts.gender_inverse),
    legal_form: Object.keys(consts.legal_form),
    identification_type: Object.keys(consts.identification_types),
    address_type: Object.keys(consts.address_types),
    transfer_type: Object.keys(consts.transfer_type),
    scenario: Object.keys(consts.transaction_direction),
    currency_code: Object.keys(consts.currencies),
    country: countryNames.filter(name => name !== 'UNKNOWN'),
    country_extended: countryNames,
};

// Text shown in the dropdown next to the stored value (the cell keeps the value itself)
const OPTION_LABELS = {
    currency_code: code => `${code} — ${consts.currencies[code]}`,
};

// [{ value, label }] for a validator, or null. Only values that actually pass their validator are
// offered (e.g. country names with an apostrophe currently fail because validateValue XML-escapes
// the value before the lookup).
const optionsCache = {};
function validatorOptions(validatorKey) {
    if (!VALIDATOR_OPTIONS[validatorKey]) return null;
    if (!optionsCache[validatorKey]) {
        const { validateValue } = require('./validation.js');
        const label = OPTION_LABELS[validatorKey] || (value => value);
        optionsCache[validatorKey] = VALIDATOR_OPTIONS[validatorKey]
            .filter(value => {
                const errors = [];
                validateValue({ key: validatorKey, name: 'option', value, errorList: errors, index: 0, row: {} });
                return errors.length === 0;
            })
            .map(value => ({ value, label: label(value) }));
    }
    return optionsCache[validatorKey];
}

// What the server ends up validating for a grid cell's text: submitGrid writes the grid to an
// xlsx (server/utils/grid_utils.js gridValueToCell) and loadData (server/utils/xml_handler.js)
// reads it back. Mirrors that round trip so live validation in the grid matches submit.
// Returns null for values the server treats as empty.
const GRID_DATE_COLUMNS = ['Date', 'Birth Date', 'Issue Date', 'Expiry Date'];
const TIME_COLUMN = 'Time of Transaction';

// Time text in the forms people paste or other tools export -> "HH:MM" (seconds dropped, like
// loadData does), or null when it isn't a time:
//   "9:05", "14:05:59", "2:05 PM", "2024-03-12 14:05", "2024-03-12T14:05:00Z", "0.5868" (Excel day fraction)
function parseTimeText(value) {
    if (value === null || value === undefined) return null;
    const text = value.toString().trim();
    let hours;
    let minutes;
    const clock = /^(?:\d{4}-\d{2}-\d{2}[ T])?(\d{1,2}):([0-5]\d)(?::[0-5]\d(?:\.\d+)?)?\s*([AaPp]\.?[Mm]\.?)?(?:Z|[+-]\d{2}:?\d{2})?$/.exec(text);
    if (clock) {
        hours = Number(clock[1]);
        minutes = Number(clock[2]);
        if (clock[3]) {
            if (hours < 1 || hours > 12) return null;
            hours = (hours % 12) + (/^p/i.test(clock[3]) ? 12 : 0);
        }
    } else if (/^0?\.\d+$/.test(text)) {
        // Excel stores a time as a fraction of a day; round to the second first so 14:04:59.9996 is 14:05
        const seconds = Math.round(Number(text) * 86400);
        hours = Math.floor(seconds / 3600);
        minutes = Math.floor((seconds % 3600) / 60);
    } else {
        return null;
    }
    if (hours > 23) return null;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

function gridCellValidationValue(columnName, value) {
    if (value === null || value === undefined) return null;
    const text = value.toString().trim();
    if (text === '') return null;
    if (GRID_DATE_COLUMNS.includes(columnName)) {
        const match = /^(\d{4}-\d{2}-\d{2})/.exec(text);
        if (match) {
            const date = new Date(`${match[1]}T00:00:00.000Z`);
            if (!isNaN(date) && date.toISOString().slice(0, 10) === match[1]) return match[1];
        }
        return text;
    }
    if (columnName === TIME_COLUMN) return parseTimeText(text) || text;
    if (/^-?(0|[1-9]\d{0,14})(\.\d+)?$/.test(text)) {
        const number = Number(text);
        return number === 0 ? null : number; // loadData skips falsy cells
    }
    return text;
}

module.exports = {
    fieldsInUse,
    reportToFielsMap,
    templateValidationRules,
    gridCellValidationValue,
    validatorOptions,
    GRID_DATE_COLUMNS,
    TIME_COLUMN,
    parseTimeText,
};
